import { render } from "./AudioSettings.vue?vue&type=template&id=661b6716&scoped=true"
import script from "./AudioSettings.vue?vue&type=script&lang=js"
export * from "./AudioSettings.vue?vue&type=script&lang=js"

import "./AudioSettings.vue?vue&type=style&index=0&id=661b6716&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661b6716"]])

export default __exports__